"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable no-unused-vars */

exports.default = {
    rules: {
        2514541: function _(region) {
            return false;
        }, //drop Cirpus
        3263728: function _(region) {
            return false;
        }, //drop Cirpus
        3263726: function _(region) {
            return false;
        }, //drop Cirpus

        1152720: function _(region) {
            return false;
        }, //drop Ab
        1152717: function _(region) {
            return false;
        }, //drop Oset

        1741311: function _(region) {
            return region.hasParent(1741311) && region.level == 4;
        } //RS w/o RS-KM
    }
};